import laborSummaryComponentUrl from './reportsSummaryComponent.html';
import timeoffSummaryComponentUrl from './timeoffSummaryComponent.html';

const summaryUrls = {
  laborSummaryComponentUrl,
  timeoffSummaryComponentUrl,
};

export default {
  templateUrl($attrs) {
    'ngInject';

    return summaryUrls[`${$attrs.type || 'labor'}SummaryComponentUrl`];
  },
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "reports" */ './reportsSummaryComponentCtrl')).default,
  controllerAs: 'ctrl',
  transclude: true,
  bindings: {
    summary: '<',
    isLoading: '<?',
    showDurationsAsDecimals: '<?',
    summarySchema: '<',
  },
};
